/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 15:55:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-04 17:47:06
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent/index.tsx
 */
import React from 'react';

import css from './css.less';

import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

const GeneralCollapseContent = (props) => {
  const { className, children, err = [] } = props;

  return (
    <div className={`${css.container} ${className || ''}`}>
      <ErrorDisplay2 err={err} hasError />
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
};
export default GeneralCollapseContent;
